export default function makeFullName(firstName, lastName) {
  return [firstName, lastName]
    .filter((name) => name)
    .join(' ')
    .trim();
}
